import React from "react";
import Page from "@jumbo/shared/Page";
import TrademarkSearch from "./TrademarkSearch";
import TrademarkDetail from "./TrademarkDetail";
import TenantAdminRoute from "../../routes/TenantAdminRoute";

const TM_routes = [
  {
    path: "/trademark-search",
    element: <TenantAdminRoute element={<Page component={TrademarkSearch} />} />,
  },
  {
    path: "/trademark-search/:resultId",
    element: <TenantAdminRoute element={<Page component={TrademarkDetail} />} />,
  },
];

export default TM_routes;
